import React from "react";
import ScaledLogo from "./ScaledLogo";
import styles from "./materials.module.scss";

const InstagramSpeaker = ({ speaker, event, bgColor, textColor }) => (
  <div className={styles.igSpeaker} style={{ "--mat-bg": bgColor, "--mat-text": textColor }}>
    <div className={styles.igSpeakerPhotoArea}>
      {speaker.photoUrl ? (
        <img
          src={speaker.photoUrl}
          alt={speaker.name}
          crossOrigin="anonymous"
          className={styles.igSpeakerPhoto}
        />
      ) : (
        <div className={styles.igSpeakerPhotoPlaceholder} />
      )}
    </div>
    <div className={styles.igSpeakerBar}>
      <div className={styles.igSpeakerInfo}>
        <p>{speaker.name}</p>
        <p>{speaker.title}</p>
        <p>{speaker.businessName}</p>
      </div>
      <div className={styles.igSpeakerBarLogo}>
        <ScaledLogo color={event.color} width={128} height={148} />
      </div>
    </div>
  </div>
);

export default InstagramSpeaker;
